export const BT_TEACHER_POSITION_TYPE_OPTIONS = [
  '목사',
  '전도사',
  '권사',
  '장로',
  '집사',
  '성도',
  '기타',
];

export const BT_TEACHER_AWANA_ROLE_OPTIONS = [
  '팀교사',
  '조정관',
  '감독관',
  '게임디렉터',
  '서기',
  '방송',
  '학생교사',
  '기타',
];

export const BT_TEACHER_CLUB_OPTIONS = [
  'CUBBIES',
  'JOURNEY',
  'PUGGLES',
  'SPARKS',
  'T&T',
  'TREK',
];

export const normalizeBTTeacherForm = <T extends Record<string, any>>(teacher: T) => ({
  ...teacher,
  positionType: teacher.positionType || '',
  awanaRole: teacher.awanaRole || '',
  club: teacher.club || '',
});
